function isCategoricalDescriptor(descriptor) {
    return descriptor["@type"] === "categorical";
}

function isNumericalDescriptor(descriptor) {
    return descriptor["@type"] === "numerical";
}

const emptyTableMetaDescriptor = {
    majorityType: "UNKNOWN",
    majorityTypeFraction: 1.0,
    typeDistribution: {
        STRING: 0,
        INTEGER: 0,
        DOUBLE: 0,
        UNKNOWN: 0,
    },
    valueDescription: [
        {
            "@type": "categorical",
            histogram: [],
        },
    ],
};

function getValueDescriptorValue(descriptor) {
    if (isCategoricalDescriptor(descriptor))
        return descriptor.histogram;
    if (isNumericalDescriptor(descriptor))
        return descriptor.histogram;
    if (isUrlDescriptor(descriptor))
        return descriptor.randomSelection;
    return [];
}

function isUrlDescriptor(descriptor) {
    return descriptor["@type"] === "url";
}

export { emptyTableMetaDescriptor, getValueDescriptorValue, isCategoricalDescriptor, isNumericalDescriptor, isUrlDescriptor };
//# sourceMappingURL=index.mjs.map
